---
pageId: first-tracker
title: Utwórz pierwszy tracker
description: Zacznij obserwować z Samllą przez gotowy szablon albo pełny formularz tworzenia trackera.
category: getting-started
order: 1
lang: pl
slug: pierwsze-kroki/pierwszy-tracker
updated: 2026-08-05
---

Najszybszy sposób, żeby zrozumieć Samllę, to utworzyć jeden tracker i zapisać jeden wpis. Ta pojedyncza pętla — zapisz, spójrz wstecz, zauważ — to cały produkt w miniaturze.

## Pierwsze logowanie

Przy pierwszej wizycie Samlla otwiera się jednym pytaniem: **„Co chcesz obserwować?"**. Dalej możesz zacząć od gotowego zestawu:

- **Wybierz gotowy zestaw.** Pod „Albo wybierz gotowy zestaw" czeka siedem startowych szablonów — Woda, Sen, Kroki, Siłownia, Nastrój, Czytanie, Praca głęboka. Zaznacz dowolną liczbę i naciśnij **Dodaj zaznaczone** — trackery powstają od razu, każdy w pasującej kategorii.
- **Pomiń**, jeśli wolisz najpierw się rozejrzeć.

Cokolwiek wybierzesz, lądujesz w Dzienniku. Jeśli tracker powstał, Dziennik wita Cię podpowiedzią, że jest gotowy — z przyciskiem **Dodaj wpis**, który otwiera formularz szybkiego dodawania wycelowany w ten tracker.

## Tworzenie trackera później

Z pulpitu albo listy trackerów wybierz **Utwórz tracker**. Strona tworzenia daje dwa punkty startu:

- **Zacznij od szablonu.** Wybierz kategorię (Zdrowie, Sport, Umysł…), żeby zobaczyć gotowe szablony. Kliknięcie wypełnia formularz — nic jeszcze nie powstaje. Przejrzyj metryki, popraw co trzeba, dopiero wtedy zapisz.
- **Stwórz własny.** Podaj **Nazwę trackera**, opcjonalny opis i kategorię, zdecyduj, czy tracker ma metryki (przełącznik **Włącz metryki** — wyłączony oznacza tracker-dziennik z samych notatek), zdefiniuj metryki i ustaw harmonogram.

Naciśnij **Utwórz tracker** — lądujesz na stronie nowego trackera, gotowej na pierwszy wpis.

## Co dzieje się dalej

Twoje wpisy budują oś czasu w Dzienniku, dzień po dniu. Statystyki rosną razem z danymi: gdy historia jest wystarczająca, Samlla zaczyna pokazywać, co jest dla Ciebie typowe.

Plan Free obejmuje 5 trackerów — wystarczająco, żeby przejść pełną pętlę, zanim zdecydujesz, czy potrzebujesz więcej.
